import { useState, useRef, useEffect } from 'react';

interface Message {
  id: number;
  from: string;
  text: string;
  time: string;
  mine: boolean;
}

const initialMessages: Message[] = [
  { id: 1, from: 'Boostio', text: 'Ahoj Ján! Dizajn prvej stránky je hotový, prosím pozri si ho v sekcii Prehľad.', time: 'včera 14:22', mine: false },
  { id: 2, from: 'Vy', text: 'Super, pozriem to dnes večer a dám vedieť.', time: 'včera 15:04', mine: true },
  { id: 3, from: 'Boostio', text: 'Perfekt, ak bude čokoľvek na zmenu, stačí napísať sem alebo pridať komentár priamo do úlohy.', time: 'včera 15:10', mine: false },
  { id: 4, from: 'Vy', text: 'Dizajn vyzerá skvele! Len by som zmenil farbu CTA tlačidla na viac oranžovú.', time: 'dnes 9:47', mine: true },
  { id: 5, from: 'Boostio', text: 'Jasné, zapracujeme dnes. Uvidíš to v portáli hneď po aktualizácii.', time: 'dnes 10:02', mine: false },
];

export default function PortalSpravy() {
  const [messages, setMessages] = useState<Message[]>(initialMessages);
  const [input, setInput] = useState('');
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessage = () => {
    const text = input.trim();
    if (!text) return;
    const now = new Date();
    const time = `dnes ${now.getHours()}:${String(now.getMinutes()).padStart(2, '0')}`;
    setMessages((prev) => [...prev, { id: Date.now(), from: 'Vy', text, time, mine: true }]);
    setInput('');
  };

  const handleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') sendMessage();
  };

  return (
    <div className="h-full flex flex-col">
      {/* Chat header */}
      <div className="flex-shrink-0 px-6 py-3.5 border-b border-zinc-800 flex items-center gap-3">
        <div className="w-9 h-9 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
          <i className="ri-rocket-2-fill text-white text-sm" />
        </div>
        <div>
          <p className="text-white font-bold text-sm">Tím Boostio</p>
          <div className="flex items-center gap-1.5 mt-0.5">
            <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full" />
            <span className="text-emerald-400 text-xs">Online</span>
          </div>
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
        {messages.map((msg) => (
          <div key={msg.id} className={`flex items-end gap-2.5 ${msg.mine ? 'flex-row-reverse' : ''}`}>
            {!msg.mine && (
              <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mb-1">
                <i className="ri-rocket-2-fill text-white" style={{ fontSize: 10 }} />
              </div>
            )}
            <div className={`max-w-[70%] flex flex-col ${msg.mine ? 'items-end' : 'items-start'}`}>
              <div className={`px-4 py-2.5 rounded-2xl text-sm leading-relaxed ${msg.mine ? 'bg-orange-500 text-white rounded-br-sm' : 'bg-zinc-800 border border-zinc-700 text-zinc-200 rounded-bl-sm'}`}>
                {msg.text}
              </div>
              <span className="text-zinc-600 text-[10px] mt-1 px-1">{msg.time}</span>
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div className="flex-shrink-0 border-t border-zinc-800 px-6 py-4 flex items-center gap-3">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Napíšte správu..."
          className="flex-1 bg-zinc-800 border border-zinc-700 rounded-xl px-4 py-2.5 text-sm text-zinc-200 placeholder-zinc-600 outline-none focus:border-orange-500/50 transition-all"
        />
        <button
          onClick={sendMessage}
          className={`w-10 h-10 flex items-center justify-center rounded-xl border cursor-pointer transition-all whitespace-nowrap flex-shrink-0 ${input.trim() ? 'bg-orange-500 border-orange-500 text-white hover:bg-orange-400' : 'bg-zinc-800 border-zinc-700 text-zinc-600'}`}
        >
          <i className="ri-send-plane-line text-sm" />
        </button>
      </div>
    </div>
  );
}
